export enum TemplateFieldTypes {
  TEXT_CHOISE = 'TEXT_CHOISE',
  IMAGE_CHOISE = 'IMAGE_CHOISE',
  YES_NO_DECISION = 'YES_NO_DECISION',
  TEXT_AREA = 'TEXT_AREA',
}
